export const PERSONALISED_RECOMMENDER_TITLE_EXPERIMENT =
  "personalised_recommender_title_july_2022";
export const ONEPASS_APP_EXPERIMENT = "onepass_app_jul22";
export const ONEPASS_BUNNINGS_CONTENT_EXPERIMENT =
  "onepass_bunnings_content_oct_22";
